import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface PackageSelectConfig {
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
}

export const PACKAGE_SELECT_CONFIG_TOKEN = new InjectionToken<PackageSelectConfig>('package select config token');
export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current partner id');
export const MARKET_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken('token for current market id');
